import styled from 'styled-components';

export const HelpPageStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    max-width: 800px;
    margin: 0 auto;
    padding-bottom: var(--space-6);

    .page-header {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        margin-bottom: var(--space-2);
    }

    .page-title {
        margin: 0;
        font-size: var(--font-size-h3);
        font-weight: 600;
        line-height: 1.25;
        color: var(--color-white-95);
    }

    .page-desc {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }
`;

export const HelpSectionStyled = styled.section`
    padding: var(--space-5) var(--space-4);
    background: var(--color-surface);
    border-radius: var(--radius-md);

    .section-header {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: var(--space-3) var(--space-6);
        margin-bottom: var(--space-5);
    }

    .section-heading {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        min-width: 0;
    }

    .section-title {
        margin: 0;
        font-size: var(--font-size-h4);
        font-weight: 600;
        color: var(--color-white-95);
    }

    .section-desc {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }
`;

export const HelpDocListStyled = styled.ul`
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
    margin: 0;
    padding: 0;
    list-style: none;
`;

export const HelpDocItemStyled = styled.li`
    a {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--space-3);
        padding: var(--space-3) var(--space-4);
        background: var(--color-surface-secondary);
        border-radius: var(--radius-md);
    }

    .doc-title {
        margin: 0;
        font-size: var(--font-size-md);
        font-weight: 600;
        color: var(--color-white-95);
    }

    .doc-meta {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        gap: var(--space-2);
        font-size: var(--font-size-sm);
        color: var(--text-color-secondary);
    }

    a:hover .doc-title {
        color: var(--color-yellow-light);
    }
`;

export const HelpContactPanelStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    padding: var(--space-4);
    background: var(--color-surface-secondary);
    border-radius: var(--radius-md);

    .contact-label {
        margin: 0;
        font-size: var(--font-size-xs);
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: var(--text-color-secondary);
    }

    .contact-title {
        margin: 0;
        font-size: var(--font-size-xl);
        font-weight: 600;
        color: var(--color-white-95);
    }

    .contact-desc {
        margin: 0;
        font-size: var(--font-size-md);
        line-height: 1.5;
        color: var(--text-color-secondary);
    }

    .contact-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: var(--space-2);
        margin-top: var(--space-1);
    }

    .contact-actions .btn svg {
        flex-shrink: 0;
    }
`;
